import React, { Fragment } from 'react'
import { Grid, GridItem, GridProps, Text } from '@chakra-ui/react'
import {
  TransferInitiationCashTypeDisplay,
  TransferInitiationCashWebDto,
} from '../../../api/types'
import { isEmpty } from 'lodash'
import { numberToCurrency } from '../../../utils'
import { CurrencyEnum } from '../../../utils/numberToCurrency'

interface CashAssetsPreviewProps extends GridProps {
  cash?: TransferInitiationCashWebDto[]
}

const CashAssetsPreview = ({
  cash,
  ...baseGridProps
}: CashAssetsPreviewProps) => {
  if (isEmpty(cash)) {
    return null
  } else {
    const cashTransferSpan = 4
    const typeSpan = 2
    const amountSpan = 4
    const currencySpan = 2
    const fillerSpan = 9 // Should bring totalColumnSpan up to 21 for form consistency
    const totalColumnsSpan =
      cashTransferSpan + typeSpan + amountSpan + currencySpan + fillerSpan

    return (
      <Grid
        data-testid="cash-assets-preview"
        paddingLeft="1rem"
        paddingBottom="1rem"
        borderBottom="1px solid gray"
        columnGap={4}
        rowGap={4}
        templateRows={`repeat(${cash?.length}, fit-content 1fr)`}
        templateColumns={`repeat(${totalColumnsSpan}, 1fr)`}
        {...baseGridProps}
      >
        <GridItem colSpan={cashTransferSpan} rowSpan={cash?.length! + 1}>
          <Text fontWeight="semibold">Cash Transfer</Text>
        </GridItem>
        <GridItem colSpan={typeSpan}>
          <Text fontWeight="semibold">Type*</Text>
        </GridItem>
        <GridItem colSpan={amountSpan} justifySelf="end">
          <Text fontWeight="semibold">Amount*</Text>
        </GridItem>
        <GridItem colSpan={currencySpan + fillerSpan}>
          <Text fontWeight="semibold">Currency*</Text>
        </GridItem>
        {cash &&
          cash.map(({ rowId, type, amount }) => (
            <Fragment key={rowId}>
              <GridItem colSpan={typeSpan} paddingTop="0.5rem">
                {TransferInitiationCashTypeDisplay[type]}
              </GridItem>
              <GridItem
                colSpan={amountSpan}
                justifySelf="end"
                paddingTop="0.5rem"
              >
                {numberToCurrency(amount!, CurrencyEnum.usd)}
              </GridItem>
              <GridItem colSpan={currencySpan + fillerSpan} paddingTop="0.5rem">
                <Text>{CurrencyEnum.usd}</Text>
              </GridItem>
            </Fragment>
          ))}
      </Grid>
    )
  }
}

export default CashAssetsPreview
